import { render, staticRenderFns } from "./proResearch.vue?vue&type=template&id=4eb3062b&scoped=true&"
import script from "./proResearch.vue?vue&type=script&lang=js&"
export * from "./proResearch.vue?vue&type=script&lang=js&"
import style0 from "./proResearch.vue?vue&type=style&index=0&id=4eb3062b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb3062b",
  null
  
)

export default component.exports